import gql from 'graphql-tag';

export const GetAchPaymentByIdQuery = gql`
  query GetAchPaymentByIdQuery($achPaymentId: String) {
    achPayment(achPaymentId: $achPaymentId) {
     id
    _ContactId
    name
    payeeName
    bankName
    bankAccountNumberLast4
    bankRoutingNumberLast4
    accountType
    accountPurpose
    emailAddress
    }
  }
`;